import Alert from './Alert';

export default Alert;



// WEBPACK FOOTER //
// ./src/components/atoms/Alert/index.js